<template>
    <div class="modal-error">
        <div class="modal-error__content">
            <div class="modal-error__header">
                <button
                    class="modal-error__button-close btn btn-close"
                    @click="Activate_Error_Range()"
                />
            </div>
            <div class="modal-error__body">
                <h1 class="modal-error__title">
                    Error
                </h1>
                <p class="modal-error__paragraph">
                    El valor del segundo año debe ser mayor o igual al primero.
                    Por favor intenta nuevamente.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Warning',

  methods: {
    ...mapActions(['Activate_Error_Range'])
  }
}

</script>

<style scoped>
.modal-error{
  align-items: center;
  background-color: rgba(210, 212, 207, 0.89);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 4;
}

.modal-error__content {
  background-color: #fce6e0;
  padding: 1rem 2rem;
  border-radius: 1rem;
  width: 45%;
}

.modal-error__header {
  text-align: end;
}

.modal-error__body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.modal-error__title {
  text-align: center;
  color: rgb(161, 62, 62);
  margin: 0;
  width: 100%;
}

.modal-error__paragraph {
  color: rgb(39, 54, 61);
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  text-align: justify;
}
</style>